import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-use';

import AgreementPageFooter from '@/components/AgreementPageFooter';
import { getAgreementLatest } from '@/request/agreement';

import { AgreementItem } from '../agreement';

import style from './style.module.scss';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['home', 'common'])),
    },
  };
};

const CookiePolicy: React.FC = () => {
  const { t, i18n } = useTranslation(['home', 'common']);
  const state = useLocation();
  const [detail, setDetail] = useState<AgreementItem>();

  const handleAgreementLatest = async (agreementType: string) => {
    const res = await getAgreementLatest(
      agreementType as AgreementItem['agreementType'],
    );
    setDetail(res?.data || res);
  };

  useEffect(() => {
    handleAgreementLatest('STU_CENTER_COOKIE_POLICY');
  }, []);

  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-隐私条款-title'),
          description: t('common:seo-隐私条款-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-隐私条款-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-Cookie-隐私条款-title')}</title>
        <meta
          name="description"
          content={t('common:seo-Cookie-隐私条款-description')}
        />
        <meta
          name="keywords"
          content={t('common:seo-Cookie-隐私条款-关键词')}
        />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-Cookie-隐私条款-title')}
        />
      </Head>
      <div
        className={style.agreement}
        style={{
          fontFamily: `${i18n.language === 'en' ? 'Roboto' : '"PingFang SC", "Microsoft YaHei"'}`,
        }}>
        <div
          className={style.agreementDetail}
          dangerouslySetInnerHTML={{ __html: detail?.content || '' }}
        />
        <AgreementPageFooter />
      </div>
    </>
  );
};

export default CookiePolicy;
